import FeedBanner from './feed-banner';

export default FeedBanner;
